import type {AxiosRequestConfig} from 'axios';
import {PackageConfig, CustomizedItems} from './interface';

export class GetPackageConfigsRequestBuilder {
  private readonly packageConfigRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/partner-package-config',
    params: {},
  };

  id(id: string) {
    this.packageConfigRequest.url = `partner-package-config/${id}`;
    return this;
  }

  params(params: object) {
    this.packageConfigRequest.params = params;
    return this;
  }

  build() {
    return this.packageConfigRequest;
  }
}

export class CreatePackageConfigRequestBuilder {
  private readonly packageConfigRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/partner-package-config',
    params: {},
    data: {},
  };
  data(data: PackageConfig) {
    this.packageConfigRequest.data = data;
    return this;
  }

  params(params: object) {
    this.packageConfigRequest.params = params;
    return this;
  }

  build() {
    return this.packageConfigRequest;
  }
}

export class UpdatePackageConfigRequestBuilder {
  private readonly packageConfigRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/partner-package-config',
    params: {},
    data: {},
  };
  params(params: object) {
    this.packageConfigRequest.params = params;
    return this;
  }

  data(data: PackageConfig) {
    this.packageConfigRequest.data = data;
    return this;
  }

  build() {
    return this.packageConfigRequest;
  }
}

export class CreateCustomizedItemRequestBuilder {
  private readonly packageConfigRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/partner-package-config',
    params: {},
    data: {},
  };

  data(data: CustomizedItems) {
    this.packageConfigRequest.data = data;
    return this;
  }
  params(params: object) {
    this.packageConfigRequest.params = params;
    return this;
  }
  
  //The id passed here is the same as partnerId (I guess!)
   id(id: string) {
    this.packageConfigRequest.url = `partner-package-config/${id}/customized-items`;
    return this;
  }

  build() {
    return this.packageConfigRequest;
  }
}
